import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5466c417"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "bold-desc" }
const _hoisted_5 = {
  key: 0,
  class: "code"
}
const _hoisted_6 = { class: "line-wrap" }
const _hoisted_7 = { class: "line" }
const _hoisted_8 = { class: "content-wrap" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.data.qid ? `当前LINUX终端安全基线扫描结果共有${Array.isArray(_ctx.data.qid) ? _ctx.data.qid.length : 1}项不合规，请按照下面设置说明进行手动修复` : 'LINUX终端安全基线扫描项配置说明'), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.config, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "item-wrapper"
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(item.desc), 1),
        (item.commands)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("table", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.commands, (command, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(index + 1), 1)
                    ]),
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("p", {
                        class: _normalizeClass(["content", {gray: command.trim().charAt(0) === '#'}])
                      }, _toDisplayString(command), 3)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (item.images)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (imgSrc) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: imgSrc,
                  src: require('./_images/' + imgSrc),
                  class: "img-blk"
                }, null, 8, _hoisted_10))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _hoisted_11
  ]))
}